module.exports = __webpack_public_path__ + "static/img/icon7.4d54a02.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/fxcp_result/images/icon7.png
// module id = ojkF
// module chunks = 21